<ng-container>
  <div class="loader absolute" *ngIf="isLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="filters-area">
    <div class="filter">
      <c_filter_date_range [label]="'Event Time'" [isSetToday]="true" (dateRange)="dateRange($event)" [initialStartDate]="stime" [initialEndDate]="etime"></c_filter_date_range>
      <div class="v-center" style="gap: 8px">
        <!-- column filter-->
        <div class="relative" #columnFilterbox>
          <div class="btn-area ml-10">
            <div class="button button-white dense-icon-btn" (click)="toggleShowColumnFilter()">
              <div class="btn-inner dense-icon-btn filter-btn">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Columns</span>
              </div>
            </div>
          </div>
          <div class="filter-box" *ngIf="isShowColumnFilter" style="width: 180px; position: absolute; top: 30px; left: 10px;">
            <div class="select-list" #statusSelect>
              <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result selectitem">
                  <div style="color:hsla(0,0%,0%,0.87)">Columns</div>
                </div>
                <div class="select-result has-child selectitem" *ngFor="let column of filterableColumns" (click)="toggleColumnVisibility(column)">
                  <div class="check-area"><i class="material-icons check-icon" *ngIf="!isVisibleColumns[column.value]">check_box_outline_blank</i><i class="material-icons check-icon checked" *ngIf="isVisibleColumns[column.value]">check_box</i></div>
                  <div>{{column.name}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- delaer filter-->
        <div class="btn-area">
          <div class="button button-white dense-icon-btn">
            <div class="btn-inner dense-icon-btn filter-btn">
              <div *ngIf="!selectedDealer" (click)="isUnfoldDealerListDropdown = true">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Dealer Filter</span>
              </div>
              <ng-container *ngIf="selectedDealer"><i class="material-icons filter-icon">domain</i><span class="exist-filter ellipsis" *ngIf="selectedDealer" style="max-width: 200px;" (click)="isUnfoldDealerListDropdown = true">{{selectedDealer.name}}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearDealerFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="isUnfoldDealerListDropdown">
            <div class="select-list" #dealerSelect>
              <div class="search-result-input">
                <input class="list-search-input" autocomplete="off" type="text" placeholder="Search Dealer" [(ngModel)]="searchDealerTxt" (input)="searchDealer(searchDealerTxt)"/>
              </div>
              <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result has-child selectitem" *ngIf="!filteredDealerList?.length">No Data</div>
                <ng-container *ngIf="filteredDealerList?.length">
                  <div class="select-result has-child selectitem" *ngFor="let dealer of filteredDealerList" (click)="$event.stopPropagation();selectDealer(dealer)">
                    <div class="ellipsis" [class.selected]="dealer?.dealer_id == selectedDealer?.dealer_id">{{dealer.name}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <!-- site filter-->
        <div class="btn-area">
          <div class="button button-white dense-icon-btn">
            <div class="btn-inner dense-icon-btn filter-btn">
              <div *ngIf="!selectedSite" (click)="isUnfoldSiteListDropdown = true">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Site Filter</span>
              </div>
              <ng-container *ngIf="selectedSite"><i class="material-icons filter-icon">group</i><span class="exist-filter ellipsis" *ngIf="selectedSite" style="max-width: 200px;" (click)="isUnfoldSiteListDropdown = true">{{selectedSite.name}}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearSiteFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="isUnfoldSiteListDropdown">
            <div class="select-list" #siteSelect>
              <div class="search-result-input">
                <input class="list-search-input" autocomplete="off" type="text" #selectSearchInput placeholder="Search Site" [(ngModel)]="searchSiteTxt" (input)="searchSite(searchSiteTxt)"/>
              </div>
              <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result has-child selectitem" *ngIf="!filteredSiteList?.length">No Data</div>
                <ng-container *ngIf="filteredSiteList?.length">
                  <div class="select-result has-child selectitem" *ngFor="let site of filteredSiteList" (click)="$event.stopPropagation();selectSite(site)">
                    <div class="ellipsis" [class.selected]="site?.site_id == selectedSite?.site_id">{{site.name}}</div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <!-- user filter-->
        <div class="btn-area">
          <div class="button button-white dense-icon-btn">
            <div class="btn-inner dense-icon-btn filter-btn">
              <div *ngIf="!selectedUser" (click)="isUnfoldUserListDropdown = true">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>User Filter</span>
              </div>
              <ng-container *ngIf="selectedUser"><i class="material-icons filter-icon">person</i><span class="exist-filter ellipsis" *ngIf="selectedUser" style="max-width: 200px;" (click)="isUnfoldUserListDropdown = true">{{ selectedUser.name }}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearUserFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="isUnfoldUserListDropdown">
            <div class="select-list" #userSelect>
              <div class="search-result-input">
                <input class="list-search-input" autocomplete="off" type="text" placeholder="Search User" [(ngModel)]="searchUserTxt" (input)="searchUser(searchUserTxt)"/>
              </div>
              <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result has-child selectitem" *ngIf="!filteredUserList?.length">No Data</div>
                <ng-container *ngIf="filteredUserList?.length">
                  <div class="select-result has-child selectitem" *ngFor="let user of filteredUserList" (click)="$event.stopPropagation();selectUser(user)" style="overflow: hidden;">
                    <div class="v-center" style="width: 100%;justify-content: space-between;" [class.selected]="user?.user_id == selectedUser?.user_id">
                      <div style="margin-right: 10px;">{{ user.name }}</div>
                      <div class="ellipsis" *ngIf="user.email" style="font-size: 12px;color: gray;">{{ user.email }}</div>
                      <div class="ellipsis" *ngIf="user.ip" style="font-size: 12px;color: gray;">{{ user.ip }}</div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
        <!-- category filter-->
        <div class="btn-area">
          <div class="button button-white dense-icon-btn">
            <div class="btn-inner dense-icon-btn filter-btn">
              <div *ngIf="!selectedCode" (click)="isUnfoldCodeListDropdown = true">
                <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Category Filter</span>
              </div>
              <ng-container *ngIf="selectedCode"><i class="material-icons filter-icon">label_important</i><span class="exist-filter ellipsis" *ngIf="selectedCode" style="max-width: 200px;" (click)="isUnfoldCodeListDropdown = true">{{ selectedCode.code_name }}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearCodeFilter()">cancel</i></ng-container>
            </div>
          </div>
          <div class="filter-box" *ngIf="isUnfoldCodeListDropdown">
            <div class="select-list" #codeSelect>
              <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
                <div class="select-result has-child selectitem" *ngIf="!codeList?.length">No Data</div>
                <ng-container *ngIf="codeList?.length">
                  <div class="select-result has-child selectitem" *ngFor="let code of codeList" (click)="$event.stopPropagation();selectCode(code)" style="overflow: hidden;">
                    <div class="v-center" style="width: 100%;justify-content: space-between;" [class.selected]="code?.code_id == selectedCode?.code_id">
                      <div class="ellipsis">{{ code.code_name }}</div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-area">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
        <colgroup>
          <col *ngFor="let col of visibleTableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of visibleTableHeader" [sortable-column]="header.value">{{header.name}}</th>
          </tr>
        </thead>
      </table>
      <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-data'"><i class="material-icons">inventory_2</i>
        <div style="text-align: center">No Session List<br/>Please set other date range</div>
      </div>
      <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-permission'"><i class="material-icons">do_not_disturb_on</i>
        <div>Permission Denied</div>
      </div>
      <div class="table-body" *ngIf="determineElementToShow() === 'normal'">
        <table>
          <colgroup>
            <col *ngFor="let col of visibleTableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <ng-container *ngIf="!isLoading">
              <tr class="has-child" *ngFor="let session of pagedItems" (click)="goToDetail($event, session)">
                <td *ngIf="isVisibleColumns['event_id']" [class.no-contents]="!session?.event_id">{{ session?.event_id || 'No Data' }}</td>
                <td *ngIf="isVisibleColumns['site_name']">{{ session?.site_name }}</td>
                <td *ngIf="isVisibleColumns['dealer_name']">{{ session?.dealer_name }}</td>
                <td *ngIf="isVisibleColumns['user_name']">{{ session?.user_name }}</td>
                <td *ngIf="isVisibleColumns['start_time']">{{ session?.start_time | date: 'MMM/dd hh:mm:ss a' }}</td>
                <td *ngIf="isVisibleColumns['duration_time']">
                  <div class="duration_badge">{{ session?.duration }}</div>
                </td>
                <td *ngIf="hasReadSessionCodePermission && isVisibleColumns['code']">
                  <div [class.no-contents]="!session?.code_name">{{ session?.code_name || 'Unselected' }}</div>
                </td>
                <td *ngIf="hasReadSessionCodePermission && isVisibleColumns['response']">
                  <div class="--g-tooltip-content" (mouseenter)="commonService.setTooltipPosition($event, 'top-center')">
                    <div class="ellipsis note" [class.no-contents]="!session?.response">{{ session?.response || 'Unselected' }}</div>
                    <div class="--g-tooltip tooltip-background" *ngIf="session?.response" style="text-transform: none">
                      <div>{{ session?.response }}</div>
                    </div>
                  </div>
                </td>
                <td>
                  <div class="more-content" #actionMenus [id]="session?.id" (mouseenter)="setMorePosition(session)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(session)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [id]="'more-'+session?.id" [class.show]="session?.isShowMenu">
                      <div class="more-item row" (click)="goToDetail($event, session)">
                        <div class="div">View Detail</div>
                      </div>
                      <div class="more-item row" [class.disabled]="!hasCreatePublishedReportPermission" (click)="goToCreateReportPage($event, session)">
                        <div class="div">Create Report</div>
                      </div>
                      <div class="more-item row" (click)="goToSite($event, session)">
                        <div class="div">Go to Site</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- pagination-->
      <div class="pagination-area">
        <div style="font-size:12px;padding-right: 7px;"></div>
        <div class="space"></div>
        <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
          <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
          <div>of</div>
          <div>{{totalItem}}</div>
        </div>
        <div class="pagination">
          <div class="page-mover">
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
                <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
              </div>
            </div>
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
                <div class="btn-inner"><span>Next</span>
                  <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>
